<template>
  <div>
      <!-- <b-row>
          <b-col>
              {{this.getStartDate}}
          </b-col>
          <b-col>
              {{this.getEndDate}}
          </b-col>
          <b-col>
              {{this.getSelectOperator}}
          </b-col>
          <b-col>
              {{this.getSelectUser}}
          </b-col>
          <b-col>
              {{this.getSelectBank}}
          </b-col>
          <b-col>
              {{this.getKeyword}}
          </b-col>
      </b-row> -->
      <div class="card-header card-header-flex">
        <div class="d-flex flex-column justify-content-center mr-auto">
        <b-dropdown variant="Clear" text="Export ข้อมูล" class="mb-3 mr-2">
          <b-dropdown-item type="button" v-clipboard:copy="JSON.stringify(this.selectedRowKeys)"
            v-clipboard:success="onCopy" v-clipboard:error="onError"><i class="fa fa-copy mr-1" />Copy!
          </b-dropdown-item>
          <b-dropdown-item @click="checkDataExcel(json_data)" v-if="statusKey === 1">
            <download-excel :data="json_data" :fields="json_fields" :name="getNameExport()">
              <i class="fa fa-file-excel-o mr-1" />Export Excel Select
            </download-excel>
          </b-dropdown-item>
          <b-dropdown-item @click="checkDataExcel(json_data_block)" v-else>
            <download-excel :data="json_data_block" :fields="json_fields_block" :name="getNameExport()">
              <i class="fa fa-file-excel-o mr-1" />Export Excel Select
            </download-excel>
          </b-dropdown-item>
          <b-dropdown-item>
            <download-excel :data="dataExport" :fields="json_fields" :name="getNameExport()">
              <i class="fa fa-file-excel-o mr-1" />Export Excel All
            </download-excel>
          </b-dropdown-item>
        </b-dropdown>
      </div>
        <div class="d-flex flex-column justify-content-center">
            <a class="btn btn-primary" href="javascript: void(0);" @click="getDataUserBank()"><i class="fe fe-rotate-cw mr-1" /> รีเฟรช</a>
        </div>
      </div>
      <a-tabs default-active-key="1" @change="callback">
        <a-tab-pane key="1" tab="บัญชีปกติ">
          <a-table :columns="columns" :loading="isLoadingTable" :dataSource="dataTable" rowKey='bankAcountCode' :row-selection="rowSelection"
            :scroll="{ x: 1300 }" :pagination="{defaultPageSize: 10, pageSizeOptions: ['10', '20', '30', '40', '50', '100'], showSizeChanger : true }">
            <h6 slot="status" slot-scope="status, record">
              <div>
                <b-badge href="#" @click="reCheckBank(record.bankAcountCode, record.operatorCode, status)"
                  :variant="getStatus('userBank',status).color">{{getStatus('userBank',status).name}}</b-badge>
              </div>

            </h6>
            <span slot="block" slot-scope="block, record">
              <div>
                <b-badge href="#" @click="useAction(record.bankAcountCode,record.block)" pill :variant="getStatus('blocks',record.block).color">{{getStatus('blocks',record.block).name}}
                </b-badge>
              </div>
            </span>
          </a-table>
        </a-tab-pane>
        <a-tab-pane key="2" tab="บัญชีที่ถูกบล็อคการใช้งาน" force-render>
          <a-table :columns="columnsBlock" :loading="isLoadingTable" :dataSource="dataTable" rowKey='bankAcountCode' :row-selection="rowSelection"
            :scroll="{ x: 1300 }" :pagination="{defaultPageSize: 10, pageSizeOptions: ['10', '20', '30', '40', '50', '100'], showSizeChanger : true }">
            <h6 slot="status" slot-scope="status">
              <div>
                <b-badge
                  :variant="getStatus('userBank',status).color">{{getStatus('userBank',status).name}}</b-badge>
              </div>

            </h6>
            <span slot="block" slot-scope="block, record">
              <div>
                <b-badge  href="#" @click="useAction(record.bankAcountCode,record.block)" pill :variant="getStatus('blocks',record.block).color">{{getStatus('blocks',record.block).name}}
                </b-badge>
              </div>
            </span>
          </a-table>
        </a-tab-pane>
      </a-tabs>
      <a-modal title="หมายเหตุ"  v-model="visible" ok-text="ยืนยัน" cancel-text="ยกเลิก" @ok="handleOk"
      @cancel="handleCancel">
      <a-form-model ref="ruleForm" :model="form" layout="vertical" :rules="rules">
        <div class="row">
          <div class="col-md-12">
            <a-form-model-item label="ระบุ" prop="remark">
              <a-input v-model="form.remark" />
            </a-form-model-item>
          </div>
        </div>
      </a-form-model>
  </a-modal>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { getName } from '@/utils/status'
import apiClient from '@/services/api'
import moment from 'moment'
import Swal from 'sweetalert2'
// import axios from 'axios'
const Toast = Swal.mixin({
  toast: true,
  position: 'top-end',
  showConfirmButton: false,
  timer: 3000,
  timerProgressBar: true,
  didOpen: (toast) => {
    toast.addEventListener('mouseenter', Swal.stopTimer)
    toast.addEventListener('mouseleave', Swal.resumeTimer)
  },
})
function CopyMe(TextToCopy) {
  var TempText = document.createElement('textarea')
  TempText.value = TextToCopy
  document.body.appendChild(TempText)
  TempText.select()
  document.execCommand('copy')
  document.body.removeChild(TempText)
}
export default {
// components: {
//   // eslint-disable-next-line vue/no-unused-components
//   data: {
//     json_meta: [
//       [
//         {
//           key: 'charset',
//           value: 'utf-8',
//         },
//       ],
//     ],
//   },
// },
  computed: {
    ...mapGetters({
      getStartDate: 'getStartDate',
      getEndDate: 'getEndDate',
      getSelectOperator: 'getSelectOperator',
      getSelectUser: 'getSelectUser',
      getSelectBank: 'getSelectBank',
      getKeyword: 'getKeyword',
    }),
    rowSelection() {
      const { selectedRowKeys } = this
      return {
        selectedRowKeys,
        onChange: this.onSelectChange,
        hideDefaultSelections: true,

        selections: [
          {
            key: 'all-data',
            text: 'เลือกทั้งหมด',
            onSelect: () => {
              this.selectedRowKeys = this.dataTable.map((result) => {
                return result.bankAcountCode
              })
            },
          },
          {
            key: 'del-data',
            text: 'ลบทั้งหมด',
            onSelect: () => {
              this.selectedRowKeys = []
            },
          },
        ],
        onSelection: this.onSelection,
      }
    },
  },
  watch: {
    getStartDate: function(val) {
      if (val) this.getDataUserBank()
    },
    getEndDate: function(val) {
      if (val) this.getDataUserBank()
    },
    getSelectOperator: function(val) {
      if (val) this.getDataUserBank()
    },
    getSelectUser: function(val) {
      if (val) this.getDataUserBank()
    },
    getSelectBank: function(val) {
      if (val) this.getDataUserBank()
    },
    getKeyword: function(val) {
      if (val) this.getDataUserBank()
    },
    selectedRowKeys: function(val) {
      if (val) {
        this.dataToExcel(val)
      }
    },
  },
  data() {
    return {
      json_meta: [
        [
          {
            key: 'charset',
            value: 'utf-8',
          },
        ],
      ],
      dataTable: [],
      // rowSelection: {},
      isLoadingTable: false,
      visible: false,
      statusKey: 1,
      form: {
        bankAcountCode: '',
        block: '',
        remark: '',
      },
      rules: {
        remark: [
          { required: true, message: 'หมายเหตุ', trigger: 'blur' },
        ],
      },
      columns: [
        {
          title: 'คู่ค้า',
          key: 'name',
          width: 100,
          dataIndex: 'name',
          filters: [
            { text: 'MUGHUAY', value: 'MUGHUAY' },
            { text: 'DUCKBET', value: 'DUCKBET' },
          ],
          onFilter: (value, record) => record.name.toLowerCase().includes(value.toLowerCase()),
        },
        {
          title: 'รหัสบัญชีลูกค้า',
          key: 'bankAcountCode',
          width: 200,
          dataIndex: 'bankAcountCode',
        },
        {
          title: 'รหัสสมาชิก',
          key: 'username',
          width: 200,
          dataIndex: 'username',
        },
        {
          title: 'บล็อค',
          key: 'block',
          width: 150,
          dataIndex: 'block',
          scopedSlots: {
            customRender: 'block',
          },
        },

        {
          title: 'บัญชีลูกค้า',
          key: 'bankServiceUser',
          width: 300,
          dataIndex: 'bankServiceUser',
        },
        {
          title: 'สถานะ',
          key: 'status',
          width: 150,
          dataIndex: 'userBankStatus',
          scopedSlots: {
            customRender: 'status',
          },
          fixed: 'right',
        },
        {
          title: 'หมายเหตุ',
          key: 'remark',
          width: 150,
          dataIndex: 'remark',
          fixed: 'right',
        },
        {
          title: 'คนที่ยกเลิกบล็อค',
          key: 'adminCancelUsername',
          width: 150,
          dataIndex: 'adminCancelUsername',
          fixed: 'right',
        },
        {
          title: 'วันที่สร้าง',
          key: 'createdAt',
          width: 200,
          dataIndex: 'createdAt',
          customRender: (text, row, index) => {
            return moment(text).format('DD/MM/YYYY HH:mm:ss')
          },
          fixed: 'right',
        },
        {
          title: 'วันที่อัปเดท',
          key: 'updatedAt',
          width: 200,
          dataIndex: 'updatedAt',
          customRender: (text, row, index) => {
            return moment(text).format('DD/MM/YYYY HH:mm:ss')
          },
          fixed: 'right',
        },
      ],
      columnsBlock: [
        {
          title: 'คู่ค้า',
          key: 'name',
          width: 100,
          dataIndex: 'name',
          filters: [
            { text: 'MUGHUAY', value: 'MUGHUAY' },
            { text: 'DUCKBET', value: 'DUCKBET' },
          ],
          onFilter: (value, record) => record.name.toLowerCase().includes(value.toLowerCase()),
        },
        {
          title: 'รหัสบัญชีลูกค้า',
          key: 'bankAcountCode',
          width: 200,
          dataIndex: 'bankAcountCode',
        },
        {
          title: 'รหัสสมาชิก',
          key: 'username',
          width: 200,
          dataIndex: 'username',
        },
        {
          title: 'บล็อค',
          key: 'block',
          width: 150,
          dataIndex: 'block',
          scopedSlots: {
            customRender: 'block',
          },
        },
        {
          title: 'บัญชีลูกค้า',
          key: 'bankServiceUser',
          width: 300,
          dataIndex: 'bankServiceUser',
        },
        {
          title: 'สถานะ',
          key: 'status',
          width: 150,
          dataIndex: 'userBankStatus',
          scopedSlots: {
            customRender: 'status',
          },
          fixed: 'right',
        },
        {
          title: 'หมายเหตุ',
          key: 'remark',
          width: 150,
          dataIndex: 'remark',
          fixed: 'right',
        },
        {
          title: 'คนที่บล็อค',
          key: 'adminApproveUsername',
          width: 150,
          dataIndex: 'adminApproveUsername',
          fixed: 'right',
        },
        {
          title: 'วันที่สร้าง',
          key: 'createdAt',
          width: 200,
          dataIndex: 'createdAt',
          customRender: (text, row, index) => {
            return moment(text).format('DD/MM/YYYY HH:mm:ss')
          },
          fixed: 'right',
        },
        {
          title: 'วันที่สร้าง',
          key: 'updatedAt',
          width: 200,
          dataIndex: 'updatedAt',
          customRender: (text, row, index) => {
            return moment(text).format('DD/MM/YYYY HH:mm:ss')
          },
          fixed: 'right',
        },
      ],
      json_data: [],
      json_data_block: [],
      json_fields: {
        คู่ค้า: 'name',
        รหัสบัญชีลูกค้า: 'bankAcountCode',
        รหัสสมาชิก: 'username',
        บล็อค: 'block',
        บัญชีลูกค้า: 'bankServiceUser',
        สถานะ: 'status',
        หมายเหตุ: 'remark',
        คนที่ยกเลิกบล็อค: 'adminCancelUsername',
        วันที่สร้าง: 'createdAt',
        วันที่อัปเดท: 'updatedAt',
      },
      json_fields_block: {
        คู่ค้า: 'name',
        รหัสบัญชีลูกค้า: 'bankAcountCode',
        รหัสสมาชิก: 'username',
        บล็อค: 'block',
        บัญชีลูกค้า: 'bankServiceUser',
        สถานะ: 'status',
        หมายเหตุ: 'remark',
        คนที่บล็อค: 'adminApproveUsername',
        วันที่สร้าง: 'createdAt',
        วันที่อัปเดท: 'updatedAt',
      },
      dataExport: [],
      selectedRowKeys: [],
    }
  },
  props: [
    'pageType',
  ],
  methods: {
    getNameExport() {
      return 'จัดการบัญชีธนาคารลูกค้า'
    },
    callback(key) {
      if (key === '1') {
        this.statusKey = 1
        this.getDataUserBank()
      } else {
        this.statusKey = 2
        this.getDataUserBank()
      }
      this.selectedRowKeys = []
    },
    async getDataUserBank() {
      this.isLoadingTable = !this.isLoadingTable
      const dataUserBank = await {
        startDate: this.getStartDate,
        endDate: this.getEndDate,
        operatorCode: this.getSelectOperator,
        username: this.getSelectUser,
        bankId: this.getSelectBank,
        keyword: this.getKeyword,
        statusKey: this.statusKey,
      }

      await apiClient.post('/users/getUserBank', dataUserBank).then(response => {
        const res = response.data
        if (res.code === '000') {
          this.dataTable = res.responseData.data
          this.exportAll(res.responseData.data)
        }
        this.isLoadingTable = !this.isLoadingTable
      }).catch(error => {
        Swal.showValidationMessage(
        `เกิดข้อผิดพลาด: ${error.message}`,
        )
      })
    },
    getStatus(type, status) {
      return getName(type, status)[0]
    },
    useAction(bankAcountCode, block) {
    // const titleBlock = (!block) ? 'แน่ใจหรือไม่ที่ต้องการจะบล็อคการใช้งาน' : 'แน่ใจหรือไม่ที่ต้องการจะยกเลิกบล็อคการใช้งาน'

      // Swal.fire({
      //   icon: 'info',
      //   title: titleBlock,
      //   showCancelButton: true,
      //   confirmButtonText: 'ยืนยัน',
      //   cancelButtonText: 'ยกเลิก',
      //   preConfirm: (value) => {
      //     if (value) {
      // ส่งข้อมูลอัปเดทสถานะ
      // const data = {
      //   bankAcountCode: bankAcountCode,
      //   block: !block,
      // }
      this.visible = true
      this.form = {
        bankAcountCode: bankAcountCode,
        block: !block,
      }
    //     }
    //   },
    //   allowOutsideClick: () => !Swal.isLoading(),
    // }).then((result) => {
    //   /* Read more about isConfirmed, isDenied below */
    // })
    },
    onSubmit() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          const title = (this.form.block) ? 'แน่ใจหรือไม่ที่ต้องการจะบล็อคการใช้งาน' : 'แน่ใจหรือไม่ที่ต้องการจะยกเลิกบล็อคการใช้งาน'

          Swal.fire({
            icon: 'info',
            title: title,
            showCancelButton: true,
            confirmButtonText: 'ยืนยัน',
            cancelButtonText: 'ยกเลิก',
            showLoaderOnConfirm: true,
            preConfirm: (value) => {
              if (value) {
                return apiClient.put('/users/setBlocks', this.form).then(response => {
                  if (response.status !== 200) {
                    throw new Error(response.message)
                  }
                  return response.data
                }).catch(error => {
                  Swal.showValidationMessage(
                  `เกิดข้อผิดพลาด: ${error.message}`,
                  )
                })
              }
            },
            allowOutsideClick: () => !Swal.isLoading(),
          }).then((result) => {
          /* Read more about isConfirmed, isDenied below */
            if (result.isConfirmed) {
              const iconError = (result.value.code === '000') ? 'success' : 'error'
              Toast.fire({ icon: iconError, title: result.value.message })
              this.visible = false
              this.clearForm()
              this.getDataUserBank()
            }
          })
        }
      })
    },
    clearForm() {
      this.form = {
        bankAcountCode: '',
        block: '',
        remark: '',
      }
    },
    handleOk(e) {
      this.onSubmit()
    },
    handleCancel(e) {
      this.visible = false
    },
    reCheckBank(code, operatorCode, status) {
      if (status !== 4) {
        Swal.fire({
          icon: 'info',
          title: 'คุณต้องการยืนยันผ่านการตรวจสอบหรือยกเลิกใช้งานบัญชี ?',
          showCancelButton: true,
          showDenyButton: true,
          confirmButtonText: 'ยืนยัน',
          cancelButtonText: 'ยกเลิก',
          denyButtonText: 'ยกเลิกใช้งาน',
        }).then((result) => {
          /* Read more about isConfirmed, isDenied below */
          if (result.isConfirmed) {
            this.confirmUserBank(code)
          } else if (result.isDenied) {
            this.cancelUserBank(code, operatorCode)
          }
        })
      }
    },
    async confirmUserBank(code) {
      await Swal.fire({
        title: 'แน่ใจหรือไม่ที่ต้องการยืนยันผ่านการตรวจสอบ',
        icon: 'question',
        confirmButtonText: 'ยืนยัน',
        cancelButtonText: 'ยกเลิก',
        showCancelButton: true,
        showCloseButton: true,
        showLoaderOnConfirm: true,
        preConfirm: (value) => {
          if (value) {
            return apiClient.get(`/users/reCheckBankAccount/${code}`).then(response => {
              if (response.status !== 200) {
                throw new Error(response.message)
              }
              return response.data
            }).catch(error => {
              Swal.showValidationMessage(
          `เกิดข้อผิดพลาด: ${error}`,
              )
            })
          }
        },
        allowOutsideClick: () => !Swal.isLoading(),
      }).then((result) => {
        if (result.isConfirmed) {
          const iconError = (result.value.code === '000') ? 'success' : 'error'
          Toast.fire({ icon: iconError, title: result.value.message })
          this.getDataUserBank()
        }
      })
    },
    async cancelUserBank(bankAcountCode, operatorCode) {
      await Swal.fire({
        title: 'แน่ใจหรือไม่ที่ต้องการยกเลิกใช้งานบัญชีนี้',
        icon: 'question',
        confirmButtonText: 'ยืนยัน',
        cancelButtonText: 'ยกเลิก',
        showCancelButton: true,
        showCloseButton: true,
        showLoaderOnConfirm: true,
        preConfirm: (value) => {
          if (value) {
            const data = {
              bankAcountCode: bankAcountCode,
              operatorCode: operatorCode,
            }
            return apiClient.post('/users/cancelUserBank', data).then(response => {
              if (response.status !== 200) {
                throw new Error(response.message)
              }
              return response.data
            }).catch(error => {
              Swal.showValidationMessage(
              `Request failed: ${error}`,
              )
            })
          }
        },
        allowOutsideClick: () => !Swal.isLoading(),
      }).then((result) => {
        if (result.isConfirmed) {
          const iconError = (result.value.code === '000') ? 'success' : 'error'
          Toast.fire({ icon: iconError, title: result.value.message })
          this.getDataUserBank()
        }
      })
    },
    checkDataExcel (data) {
      if (data.length === 0) {
        Toast.fire({ icon: 'error', title: 'กรุณาเลือกข้อมูลที่ต้องการ Export' })
        return false
      }
    },
    resultDataExport(item) {
      if (this.statusKey === 1) {
        const resultData = {
          name: item.name,
          bankAcountCode: item.bankAcountCode,
          username: item.username,
          block: this.getStatus('blocks', item.block).name,
          bankServiceUser: item.bankServiceUser,
          status: this.getStatus('userBank', item.userBankStatus).name,
          remark: item.remark,
          adminCancelUsername: item.adminCancelUsername,
          createdAt: moment(item.createdAt).format('DD/MM/YYYY HH:mm:ss'),
          updatedAt: moment(item.updatedAt).format('DD/MM/YYYY HH:mm:ss'),
        }
        return resultData
      } else {
        const resultData = {
          name: item.name,
          bankAcountCode: item.bankAcountCode,
          username: item.username,
          block: this.getStatus('blocks', item.block).name,
          bankServiceUser: item.bankServiceUser,
          status: this.getStatus('userBank', item.userBankStatus).name,
          remark: item.remark,
          adminApproveUsername: item.adminApproveUsername,
          createdAt: moment(item.createdAt).format('DD/MM/YYYY HH:mm:ss'),
          updatedAt: moment(item.updatedAt).format('DD/MM/YYYY HH:mm:ss'),
        }
        return resultData
      }
    },
    dataToExcel (data) {
      if (data.length > 0) {
        const dataresult = []
        data.map(result => {
        // eslint-disable-next-line no-const-assign
          const item = this.dataTable.find((dataResult) => {
            if (dataResult.bankAcountCode === result) {
              return true
            }
          })
          const resultData = this.resultDataExport(item)
          dataresult.push(resultData)
        })
        if (this.statusKey === 1) {
          this.json_data = dataresult
        } else {
          this.json_data_block = dataresult
        }
      }
    },
    exportAll (obj) {
      this.dataExport = []
      obj.map(item => {
        const resultData = this.resultDataExport(item)
        this.dataExport.push(resultData)
      })
    },
    onCopy: function (e) {
      const dataJson = JSON.parse(e.text)
      let row = ''
      if (dataJson.length > 0) {
        dataJson.map(result => {
        // eslint-disable-next-line no-const-assign
          const item = this.dataTable.find((dataResult) => {
            if (dataResult.bankAcountCode === result) {
              return true
            }
          })
          const resultData = this.resultDataExport(item)
          const convertObj = Object.values(resultData)
          const col = convertObj.join(' \t ')
          row += `${col} \n`
        })
        // this.clipboard(row)
        CopyMe(row)
        Toast.fire({ icon: 'success', title: 'success copy' })
      } else {
        Toast.fire({ icon: 'error', title: 'กรุณาเลือกข้อมูลที่ต้องการคัดลอก' })
      }
    },
    onError: function (e) {
      Toast.fire({ icon: 'error', title: 'Failed to copy texts' })
    },
    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys
    },
  },
  async created() {
    await this.getDataUserBank()
  },
}
</script>

<style>

</style>
